import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from 'react-redux';

import "./AppointmentDate.css";
import DateFormat from "../common/format/DateFormat";
import AvailabilityPlanning from "./planning/AvailabilityPlanning";
import Intervention from '../../services/Intervention';
import WarningMessage from "../common/WarningMessage";
import BoxFooter from "./BoxFooter";
import Card from "../common/Card";

class AppointmentDate extends Component {

  onOpenModal = () => {
    this.props.showPlanningModal();
  };

  onCloseModal = () => {
    this.props.hidePlanningModal();
  };

  render() {
    const {intl:{formatMessage}, showModal, canWrite, mainServices} = this.props;
    const {intervention, intervention:{journey:{properties:{reception:{dropOff={}, pickUp={}}={}}={}}={}}} = this.props;

    const startDateLayout = dropOff.duringWorkingHours === false ? "dateOnly" : "dateTimeLong";
    const endDateLayout = pickUp.duringWorkingHours === false ? "dateOnly" : "dateTimeLong";

    const planningChecked = Intervention.isConfirmed(intervention) || Intervention.isWaitingForClient(intervention);

    return (
      <Card
        title={formatMessage({id:'appointment.detail.dates.title'})}
        onAlert={!planningChecked}
        footer={canWrite &&
          <BoxFooter>
            <button type="button" className="btn btn-sm btn-primary" onClick={this.onOpenModal}>{formatMessage({id: 'appointment.detail.dates.check-planning'})}</button>
          </BoxFooter>
        }>

          {Intervention.isWaitingForClient(intervention) &&
            <WarningMessage text={formatMessage({id:'waiting.confirmation'})}/>
          }
          <div className={"d-flex"}>
            <span className="txt-muted">{formatMessage({id:'appointment.detail.dates.start'})}:</span>
            {intervention.startDate && <DateFormat className="ml-1" layout={startDateLayout} date={intervention.startDate}/>}
          </div>
          <span className="txt-muted">{formatMessage({id:'appointment.detail.dates.end'})}:</span>
          {intervention.endDate && <DateFormat className="ml-1" layout={endDateLayout} date={intervention.endDate}/>}

        {/* prevents component to be loaded */}
        {showModal && <AvailabilityPlanning visible={showModal} onClose={this.onCloseModal} mainServices={mainServices} intervention={intervention}/>}


      </Card>
    );
  }
}

const mapStateToProps = state => ({
  showModal: state.fetchIntervention.showModal
});

const mapDispatchToProps = dispatch => ({
  //dispatchFetchAppointment: (parameters, filters) => dispatch({type: 'FETCH_APPOINTMENT.REQUEST', parameters, filters})
  showPlanningModal:() => dispatch({type:"SHOW_CONFIRM_INTERVENTION_MODAL"}),
  hidePlanningModal:() => dispatch({type:"HIDE_CONFIRM_INTERVENTION_MODAL"})

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AppointmentDate))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/AppointmentDate.js